/**
 * @flow
 * @relayHash 7c8845eaa458161397058b951260fb43
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
export type configurableBlockPages_add_QueryVariables = {||};
export type configurableBlockPages_add_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ArticleSelector_viewer$ref
  |}
|};
export type configurableBlockPages_add_Query = {|
  variables: configurableBlockPages_add_QueryVariables,
  response: configurableBlockPages_add_QueryResponse,
|};
*/


/*
query configurableBlockPages_add_Query {
  viewer {
    ...ArticleSelector_viewer
    id
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "configurableBlockPages_add_Query",
  "id": null,
  "text": "query configurableBlockPages_add_Query {\n  viewer {\n    ...ArticleSelector_viewer\n    id\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "configurableBlockPages_add_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ArticleSelector_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "configurableBlockPages_add_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v0,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f8ace171707f8c9cabaff7907671cea5';
module.exports = node;



// WEBPACK FOOTER //
// src/components/configurable-blocks/__generated__/configurableBlockPages_add_Query.graphql.js